import * as React from 'react'
import { connect } from 'react-redux'
import { IApplicationState } from '../../redux/store/store'
import { useState, useEffect } from 'react'
import { VestigingEnum, vestigingen } from 'shared/models/Enum'
import SelectieButtonEnum from 'shared/components/SelectieButtonEnum'
import Cookies from 'universal-cookie'
import {
  Actions,
  ISetVestigingResponseAction,
} from 'redux/store/actions/globalAction'
import { LboCookie } from 'shared/Constants'

interface IProps {
  vestiging: VestigingEnum
  setVestiging: (
    vestiging: VestigingEnum
  ) => Promise<ISetVestigingResponseAction>
}

const Home: React.FunctionComponent<IProps> = ({ vestiging, setVestiging }) => {
  useEffect(() => {
    getVestiging()
  }, [])
  const [vestigingGeset, toggleSetVestiging] = useState(false)

  const getVestiging = () => {
    if (vestiging !== undefined) {
      toggleSetVestiging(true)
    }
  }

  const clearVestiging = () => {
    const cookies = new Cookies()
    cookies.remove(LboCookie.cookieName)
  }

  const changeVestiging = (i: VestigingEnum) => {
    if (i > 0) {
      const cookies = new Cookies()
      cookies.set(LboCookie.cookieName, i.toString(), {
        path: LboCookie.cookiePath,
        maxAge: LboCookie.cookieMaxAge,
      })
      setVestiging(i)
      toggleSetVestiging(true)
    }
  }

  return (
    <div>
      {!vestigingGeset && (
        <div>
          <h4>Kies Vestiging</h4>
          <table>
            <thead>
              <tr>
                <td>
                  <SelectieButtonEnum
                    type={VestigingEnum}
                    options={vestigingen}
                    selected={vestiging}
                    onChange={e => changeVestiging(e.target.value)}
                  />{' '}
                </td>
              </tr>
            </thead>
          </table>
        </div>
      )}
      {process.env.REACT_APP_ENV === 'dev' && vestigingGeset && (
        <button onClick={e => clearVestiging()}>Vestiging Clearen Dev</button>
      )}
    </div>
  )
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    vestiging: store.globalState.vestiging,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setVestiging: (payload: VestigingEnum) =>
      dispatch({ type: Actions.SetVestigingAction, payload }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
